import CloseIcon from '@mui/icons-material/Close';
import Box from '@o2/ui/Box';
import IconButton from '@o2/ui/IconButton';
import colors from '@o2/ui/theme/colors';
import Typography from '@o2/ui/Typography';
import { FC, ReactNode } from 'react';

interface SidesheetHeaderProps {
  header?: ReactNode;
  onClose?: () => void;
  children?: ReactNode;
  elmIds?: {
    header?: string;
    iconButton?: string;
  };
}

const Header: FC<SidesheetHeaderProps> = ({ header, onClose, children, elmIds, ...props }) => (
  <Box
    display="flex"
    borderBottom="1px solid"
    borderColor={colors.transparentGray[200]}
    px={3}
    py={2}
    justifyContent="space-between"
    alignItems="center"
    gap={2}
    {...props}
  >
    {children ? (
      children
    ) : (
      <>
        <Typography variant="h6" data-elm={elmIds?.header}>
          {header}
        </Typography>

        <IconButton
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
          data-elm={elmIds?.iconButton}
        >
          <CloseIcon />
        </IconButton>
      </>
    )}
  </Box>
);

export default Header;
